// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__26PIt","footer":"ModalCreateQualiphyProcedure_footer__1zoX9","additionData":"ModalCreateQualiphyProcedure_additionData__2V_2l"};